// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cart{
  display: inline;
  margin: 1em;
  height: max-content;
  padding: 20px 20px 0 20px;
  flex: 1 1;
  
}

.cart_list{
  padding: 10px;
  width: 100%;
  background-color: rgb(200, 255, 255);
  border-radius: .5em;
}

.cart_list h4{
  font-size: 1.5em;
  padding-bottom: 1em;
  border-bottom: 1px solid gainsboro;
}
#checkout{
  margin: 1em;
  margin-left: 25%;
  font-weight: bold;
  font-size: 1.5em;
  padding: .75em;
  border-radius: .5em;
  color: rgb(8, 70, 19);
  border: none;
}

#checkout:hover {
  background-color: #98c2f0;
}
`, "",{"version":3,"sources":["webpack://./src/components/cartSidebar.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,SAAO;;AAET;;AAEA;EACE,aAAa;EACb,WAAW;EACX,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;AACpC;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".cart{\n  display: inline;\n  margin: 1em;\n  height: max-content;\n  padding: 20px 20px 0 20px;\n  flex: 1;\n  \n}\n\n.cart_list{\n  padding: 10px;\n  width: 100%;\n  background-color: rgb(200, 255, 255);\n  border-radius: .5em;\n}\n\n.cart_list h4{\n  font-size: 1.5em;\n  padding-bottom: 1em;\n  border-bottom: 1px solid gainsboro;\n}\n#checkout{\n  margin: 1em;\n  margin-left: 25%;\n  font-weight: bold;\n  font-size: 1.5em;\n  padding: .75em;\n  border-radius: .5em;\n  color: rgb(8, 70, 19);\n  border: none;\n}\n\n#checkout:hover {\n  background-color: #98c2f0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
